"use client";

import React from "react";
import { Facebook, Instagram, Linkedin, Twitter } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="flex flex-col gap-3">
        {[1, 2, 3, 4].map((_, i) => <li key={i} data-index={i} className="h-5 w-24 bg-slate-800 animate-pulse rounded-md" />)}
      </ul>;
  }
  return <ul className="flex flex-col gap-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-slate-400 hover:text-white transition-colors text-sm font-medium">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function FooterEssentials() {
  const socialLinks = [{
    icon: Facebook,
    href: "#",
    label: "Facebook"
  }, {
    icon: Twitter,
    href: "#",
    label: "Twitter"
  }, {
    icon: Instagram,
    href: "#",
    label: "Instagram"
  }, {
    icon: Linkedin,
    href: "#",
    label: "LinkedIn"
  }];
  return <section data-section-id="170953" id="site-footer" className="bg-[#1E293B] py-[100px] dark">
      <div className="container mx-auto px-6 max-w-7xl">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8">
          
          {}
          <div className="flex flex-col gap-6 lg:pr-8">
            <p className="text-slate-400 text-sm leading-relaxed">FocusPath: Leveraging decades of Global 500 transformation experience to guide small and medium businesses through the next era of AI-driven optimization and agentic solutions.</p>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="text-white font-sans text-lg font-bold tracking-tight">
              Services
            </h3>
            <MenuProvider menu_id="91">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          

          {}
          
        </div>

        {}
        <div className="mt-24 flex flex-col gap-8">
          <Separator className="bg-slate-700" />
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-[10px] uppercase tracking-widest text-slate-500 font-medium">
            <p>
              &copy; {new Date().getFullYear()} FocusPath Consulting. All rights reserved.
            </p>
            <div className="flex gap-6">
              <Link to="#" className="hover:text-white transition-colors">
                Privacy Policy
              </Link>
              <Link to="#" className="hover:text-white transition-colors">
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>;
}